import { useEffect } from 'react';
import { useLocation } from 'react-router';

import { useIsFirstRenderRef } from '#/hooks/useIsFirstRenderRef';
import { postEmbedSearchWidgetMessage } from '#/modules/embedSearchWidget/utils/postEmbedSearchWidgetMessage';

export function EmbedSearchWidgetLayoutScrollRestoration() {
  const location = useLocation();

  const { isFirstRenderRef } = useIsFirstRenderRef();
  useEffect(() => {
    if (isFirstRenderRef.current) return;

    const hashElement = location.hash
      ? document.getElementById(location.hash.substring(1))
      : null;

    if (hashElement) {
      setTimeout(() => {
        hashElement.scrollIntoView();
        // Wait just a little bit for the page to load before scrolling
      }, 100);
    } else postEmbedSearchWidgetMessage({ type: 'idealist-scroll-top' });
  }, [isFirstRenderRef, location]);

  return null;
}
